import { FormTextareaField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PaymentAmountSection } from '../../../common/PaymentAmountSection';
import { useDefaultFormContext } from '../useDefaultFormValues';
import { PaymentCommonSection } from '../../../common/PaymentCommonSection';
import { ProcessPaymentFormField } from '../ProcessPaymentFormSchema';
import { PaymentTerminalSelectField } from './PaymentTerminalSelectField';
import { filterPaymentTerminals } from './utils';

export const MewsTerminalFormFields = ({ hideLinkPaymentToPlan = false }: { hideLinkPaymentToPlan?: boolean }) => {
    const { canLinkInvoicesConfig } = useDefaultFormContext();

    return (
        <>
            <PaymentCommonSection hideLinkPaymentToPlan={hideLinkPaymentToPlan} />
            <PaymentTerminalSelectField
                helperTextKey={TextKey.ProcessPaymentMewsPaymentsMewsTerminalPaymentPaymentTerminalSelectHint}
                terminalFilter={filterPaymentTerminals(canLinkInvoicesConfig)}
            />
            <PaymentAmountSection />
            <FormTextareaField name={ProcessPaymentFormField.Notes} rows={1} label={lt('Notes')} />
        </>
    );
};
